export default "__VITE_ASSET__XWxvIKP4__"